export enum authRoutes {
  SIGN_IN = "/logowanie",
  SIGN_UP = "/rejestracja",
  RESET_PASSWORD = "/odzyskiwanie-hasla",
}

export enum accountRoutes {
  ADDRESSES = "/adresy",
  NEW_ADDRESS = "/adresy/nowy-adres",
  PERSONAL_DATA = "/dane-osobiste",
  RETURN_FORM = "/formularz-zwrotu",
  ORDERS_HISTORY = "/historia-zamowien",
  ACCOUNT = "/moje-konto",
  RETURN_PRODUCTS = "/zwroty-produktow",
}
